/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Feature_Packs_TitleInputs */

const en_platform_feature_packs_title = /** @type {(inputs: Platform_Feature_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry packs and payments`)
};

const pl_platform_feature_packs_title = /** @type {(inputs: Platform_Feature_Packs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karnety i płatności`)
};

/**
* | output |
* | --- |
* | "Entry packs and payments" |
*
* @param {Platform_Feature_Packs_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_feature_packs_title = /** @type {((inputs?: Platform_Feature_Packs_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Feature_Packs_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_feature_packs_title(inputs)
	return en_platform_feature_packs_title(inputs)
});